"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasBrowserDNT = exports.hasExplicitDNT = void 0;
var hasExplicitDNT = function () {
    var LOGSPOT_DNT = "lgspt_dnt";
    var urlSearchParams = new URLSearchParams(window.location.search);
    var params = Object.fromEntries(urlSearchParams.entries());
    var queryWithDNT = typeof params.dnt !== "undefined";
    var disableTracking = queryWithDNT || localStorage.getItem(LOGSPOT_DNT) === "1";
    if (queryWithDNT) {
        localStorage.setItem(LOGSPOT_DNT, "1");
    }
    return disableTracking;
};
exports.hasExplicitDNT = hasExplicitDNT;
var hasBrowserDNT = function () {
    return (navigator.doNotTrack === "1" ||
        navigator.doNotTrack === "yes" ||
        window.doNotTrack === "1");
};
exports.hasBrowserDNT = hasBrowserDNT;
